import { DateTime } from 'luxon';
import { TableShiftPlanningListItem } from 'ogp/services/shift-service.types';

export const sortTableShiftPlanningItems = (
  items: TableShiftPlanningListItem[]
): TableShiftPlanningListItem[] => {
  return [...items].sort((firstItem, secondItem) => {
    const firstDate = DateTime.fromISO(firstItem.dateTime.fromDateTime);
    const secondDate = DateTime.fromISO(secondItem.dateTime.fromDateTime);
    return firstDate.toMillis() - secondDate.toMillis();
  });
};

export const getMultiDayShiftGroupSizes = (
  items: TableShiftPlanningListItem[]
): Record<string, number> => {
  return items.reduce<Record<string, number>>((groupSizes, item) => {
    if (item.multiDayShiftId == null) {
      return groupSizes;
    }

    groupSizes[item.multiDayShiftId] = (groupSizes[item.multiDayShiftId] ?? 0) + 1;
    return groupSizes;
  }, {});
};
